// src/utils/imageUtils.js

/**
 * Read a File into a data-URL.
 */
export function fileToDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

/**
 * Crop a data-URL to a centered square, then resize to sizePx×sizePx.
 * Default is 280×280.
 */
export function cropAndResizeDataURL(dataUrl, sizePx = 280) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const minSide = Math.min(img.width, img.height);
      const sx = (img.width - minSide) / 2;
      const sy = (img.height - minSide) / 2;
      const canvas = document.createElement('canvas');
      canvas.width = sizePx;
      canvas.height = sizePx;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, sx, sy, minSide, minSide, 0, 0, sizePx, sizePx);
      resolve(canvas.toDataURL('image/jpeg'));
    };
    img.src = dataUrl;
  });
}
